import React, { Component } from 'react';
import API from '../../api/api';
import './railStatistical.less';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import { Table, Button, DatePicker, message, ConfigProvider, Select, Input } from 'antd';
const { RangePicker } = DatePicker;
const { Option } = Select;
const key = 'updatable';

class TourStatistical extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        crewList: [], //导览使用 列表数据
        sumConNum: '',
        sumGroupNum: '',
        sumPromoterNum: '',
        columnsGuideList: [//导览使用数据
            {
                title: '乘务员编号',
                dataIndex: 'crewNumber',
                key: 'crewNumber',
            },
            {
                title: '乘务员姓名',
                dataIndex: 'crewName',
                key: 'crewName',
            },
            {
                title: '核销数量',
                dataIndex: 'conNum',
                key: 'conNum',
            },
            {
                title: '推广数',
                dataIndex: 'promoterNum',
                key: 'promoterNum',
            },
            {
                title: '群聊数',
                dataIndex: 'groupNum',
                key: 'groupNum',
            }
        ],

        guideListSearchCondition: {//导览使用数据搜索条件
            startTime: new Date(new Date().toLocaleDateString()).getTime() / 1000,
            endTime: new Date(new Date().toLocaleDateString()).getTime() / 1000 + 86400,
            crewNumber: '',
            playId: ''
        },

        jobType: 1,
        isAll: 1
    }

    componentDidMount() {
        let { guideListSearchCondition } = this.state;
        console.log(this.props.match.params.playId);
        guideListSearchCondition.playId = this.props.match.params.playId;
        this.setState({ guideListSearchCondition })
    }

    async getListData(e, isExport) {
        console.log('isExport', isExport)
        const { guideListSearchCondition, jobType, isAll } = this.state;
        if (isExport) {
            let url = `${window.location.origin}/promotion/v1/topTen/crewCount?startTime=${guideListSearchCondition.startTime}&endTime=${guideListSearchCondition.endTime}&crewNumber=${guideListSearchCondition.crewNumber}&playId=${guideListSearchCondition.playId}&isExport=${isExport}`
            window.location.href = url;
            return;
        }
        message.loading({ content: '查询中...', key });
        console.log('guideListSearchCondition', guideListSearchCondition)
        guideListSearchCondition.jobType = jobType;
        guideListSearchCondition.isAll = isAll;
        let result = await API.topTenCrewCount(guideListSearchCondition);
        if (result.status == 1) {
            if (isExport) return;
            message.success({ content: '成功', key, duration: 0.6 });
            let { sumConNum, sumGroupNum, sumPromoterNum, crewList, excelUrl } = result.data;
            this.setState({ crewList, sumConNum, sumGroupNum, sumPromoterNum, excelUrl })
            return
        }
        message.error({ content: result.msg, key, duration: 1 });
    }

    onSearchDateChange(date) {
        let { guideListSearchCondition } = this.state;
        console.log('date', date)
        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = ''; endTime = '';
        } else {
            startTime = new Date(date[0].format('L')).getTime() / 1000;
            endTime = (new Date(date[1].format('L')).getTime() + 86400000) / 1000
        }
        guideListSearchCondition.startTime = startTime;
        guideListSearchCondition.endTime = endTime;
        this.setState({ guideListSearchCondition });
    }

    inputNumberChange(event) {
        let { guideListSearchCondition } = this.state;
        guideListSearchCondition.crewNumber = event.target.value;
        this.setState({ guideListSearchCondition })
    }

    onSelectChange(type, value) {//下拉框更改
        if (type == 'jobType') {
            this.setState({ jobType: value })
        }
        if (type == 'isAll') {
            this.setState({ isAll: value })
        }
    }

    render() {
        const {
            columnsGuideList,
            crewList,
            sumConNum,
            sumGroupNum,
            sumPromoterNum,
            jobType,
            isAll
        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>
                <div className="railStatistical">
                    <div className='top'>
                        “椰汁免费领 欢乐海铁行 ”财务对账系统
                    </div>
                    <div className="searchPane">
                        <div className="leftCondition">
                            <RangePicker
                                defaultValue={[moment(new Date()), moment(new Date())]}
                                placeholder={['开始日期', '结束日期']}
                                className="rangePicker"
                                format="YYYY-MM-DD"
                                onChange={this.onSearchDateChange.bind(this)}
                            ></RangePicker>
                            <Select className="selectBlock" defaultValue={jobType} onChange={this.onSelectChange.bind(this, 'jobType')}>
                                <Option value={0}>全部</Option>
                                <Option value={1}>在职</Option>
                            </Select>
                            <Select className="selectBlock" defaultValue={isAll} onChange={this.onSelectChange.bind(this, 'isAll')}>
                                <Option value={0}>全部</Option>
                                <Option value={1}>仅看有数据</Option>
                            </Select>
                            <div className='InputNumber'>
                                <Input
                                    placeholder='请输入乘务员编号'
                                    type='number'
                                    onPressEnter={(event) => this.getListData(event)}
                                    onChange={this.inputNumberChange.bind(this)} />
                                <div className='tips'>*不输入编号默认查询全部员工</div>
                            </div>
                            <Button onClick={this.getListData.bind(this)}>查询</Button>
                            <Button onClick={(e) => this.getListData(e, 1)}>导出Excel</Button>
                        </div>
                    </div>
                    {
                        crewList && crewList.length > 0 &&
                        <div className='total'>
                            <span>核销总数量：{sumConNum}</span>
                            <span>推广总数量：{sumPromoterNum}</span>
                            <span>群聊总数量：{sumGroupNum}</span>
                        </div>
                    }

                    <Table
                        columns={columnsGuideList}
                        dataSource={crewList}
                        rowKey={(row, index) => 'activationList' + row.showId + '-' + index}
                    />
                </div>
            </ConfigProvider>
        )
    }
}

export default TourStatistical;